import { type Component } from 'solid-js';
import Dividends from '~/features/dividends';

// What actually landed, as opposed to what the projection expects to. The pane
// carries its own Monthly/Payments/By symbol switch, so the page is just the
// room to show more than eight rows of it.
const PaymentsPage: Component = () => (
    <div class='flex-1 min-w-0'>
        <Dividends />
    </div>
);

export default PaymentsPage;
